import React, { useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export const DataExportButton = ({ variant = "outline" }) => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/auth/export", { responseType: "blob" });
      const name = (res.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "waterplanner-datenauskunft.zip";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Datenauskunft heruntergeladen");
    } catch (_e) {
      toast.error("Download fehlgeschlagen, bitte erneut versuchen.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant={variant} onClick={download} disabled={busy} className="gap-2" data-testid="data-export-btn">
      <FileDown className="h-4 w-4" /> {busy ? "Wird erstellt…" : "Meine Daten herunterladen"}
    </Button>
  );
};

export default function DataExportCard() {
  return (
    <Card data-testid="data-export-card">
      <CardContent className="space-y-3 p-6">
        <h2 className="flex items-center gap-2 text-lg font-semibold"><FileDown className="h-5 w-5" /> Datenauskunft (Art. 15/20 DSGVO)</h2>
        <p className="text-sm text-muted-foreground">
          Laden Sie alle über Ihr Konto gespeicherten Daten als ZIP-Datei herunter: eine JSON-Datei (maschinenlesbar, zur Übertragung an
          andere Anbieter) und Excel-taugliche CSV-Tabellen zu Konto, Buchungen, Anträgen, Nachrichten, Messwerten, Erinnerungen und Anmeldungen.
        </p>
        <DataExportButton />
      </CardContent>
    </Card>
  );
}
